import type { Integrations } from "./types";

export type WriteMode = Integrations["autotask"]["write_mode"];

/** What each write mode means here: as Health and the switch on Mappings →
 * Autotask settings say it (ADR 0052). */
export const WRITE_MODE_TEXT: Record<WriteMode, string> = {
  off: "Off: nothing is written to Autotask here",
  allowlist: "Allowlist: only for the companies on this environment's allowlist",
  on: "On: for every client",
};
